import React from 'react';
import { Helmet } from 'react-helmet-async';

function SEO({title, description, type, image=`${window.location.origin}${process.env.PUBLIC_URL}/BD-Logo-1200x630.jpeg`, keywords=null}) {
  var default_keywords = "BookDoc,search and book,appointments,clinics,free,booking,instant,online";
  if(keywords){
    default_keywords += keywords
  }else{
    default_keywords += ',specialist,hospital,health,doctors'
  }
  return (
    <Helmet>
      { /* Standard metadata tags */ }
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keywords' content={default_keywords} />
      { /* End standard metadata tags */ }
      { /* Facebook tags */ }
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image"  content={image} />
      { /* End Facebook tags */ }
      { /* Twitter tags */ }
      <meta name="twitter:card" content={type} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      { /* End Twitter tags */ }
    </Helmet>
  )
}

export default SEO;